import {cloneDeep} from 'lodash';
import * as Helpers from './InstallationHelperFunctions'



export function JobListUnassignedReducer(state = Helpers.UnassignedJobList(), action) {
    switch (action.type) {

        case 'jobList/UNASSIGNED':
            return Helpers.UnassignedJobList();
        default:
            if (action.listType !== 'unassigned') {
                return state;
            }
            switch (action.type) {
                case 'sort/SORT_AZ':
                    return cloneDeep(state).sort((a, b) => a.name.localeCompare(b.name));
                case 'sort/SORT_NEW':
                    return Helpers.sortListByDate(cloneDeep(state), "productionComplete", "desc");
                case 'sort/SORT_OLD':
                    return Helpers.sortListByDate(cloneDeep(state), "productionComplete");
                case 'filter/NO_FILTER':
                    return Helpers.UnassignedJobList();
                case "filter/FILTER_JOBS":                                    
                    return Helpers.FilterQueryJobs(cloneDeep(state), action.filterOptions, "productionComplete");   
                case "job/ASSIGNED":            
                    return Helpers.deleteJob(action.job);
                default:
                    return state;
            }

    }
}

export function JobListAssignedReducer(state = Helpers.initialJobListState, action) {
    switch (action.type) {
        case 'jobList/ASSIGNED':
            return Helpers.AssignedJobList();
        default:
            if (action.listType !== 'assigned') {
                return state;
            }
            switch (action.type) {
                case 'sort/SORT_AZ':
                    return cloneDeep(state).sort((a, b) => a.name.localeCompare(b.name));
                case 'sort/SORT_NEW':
                    return Helpers.sortListByDate(cloneDeep(state), "installerAssigned", "desc");
                case 'sort/SORT_OLD':
                    return Helpers.sortListByDate(cloneDeep(state), "installerAssigned");
                case 'filter/NO_FILTER':
                    return Helpers.AssignedJobList();
                case "filter/FILTER_JOBS":
                    return Helpers.FilterQueryJobs(cloneDeep(state), action.filterOptions, "installerAssigned");
                default:
                    return state;
            }
    }
}

export function JobListCompletedReducer(state = Helpers.initialJobListState, action) {
    switch (action.type) {
        case 'jobList/COMPLETED':
            return Helpers.CompletedJobList();
        default:
            if (action.listType !== 'completed') {
                return state;
            }
            switch (action.type) {
                case 'sort/SORT_AZ':
                    return cloneDeep(state).sort((a, b) => a.name.localeCompare(b.name));
                case 'sort/SORT_NEW':
                    return Helpers.sortListByDate(cloneDeep(state), "installationComplete", "desc");
                case 'sort/SORT_OLD':
                    return Helpers.sortListByDate(cloneDeep(state), "installationComplete");
                case 'filter/NO_FILTER':
                    return Helpers.CompletedJobList();
                case "filter/FILTER_JOBS":
                    return Helpers.FilterQueryJobs(cloneDeep(state), action.filterOptions, "installationComplete");
                default:
                    return state;
            }
    }
}

export function JobListSkimReducer(state = Helpers.SkimJobList(), action) {
    switch (action.type) {
        case 'jobListSkim/UPDATE':
            return Helpers.SkimJobList();
        default:
            return state;
    }
}

export function SortReducer(state = "Newest", action) {
    switch (action.type) {
        case 'sort/SORT_NEW':
            return "SortNew";
        case 'sort/SORT_OLD':
            return 'SortOld';
        case 'sort/SORT_AZ':
            return "SortAtoZ";
        default:
            return state;
    }
}

export function FilterReducer(state = "None", action) {
    switch (action.type) {
        case 'filter/NO_FILTER':
            return "None";
        case 'filter/BY_INSTALLER':
            return "By [Installer]";
        case 'filter/BY_CUSTOMER':
            return "By [Customer]";
        default:
            return state;
    }
}

export function InstallerListInstallerJobReducer(state = Helpers.InstallerList(), action) {
    switch (action.type) {
        case 'installerList/UPDATE':
            return Helpers.InstallerList();
        case 'installerList/SORT_AVAILABILITY':
            const [sortedList, installerJobs] = Helpers.SortInstallerListByVehicleEvents(cloneDeep(state), action.date, action.events);
            return [sortedList, installerJobs]; 
        default:
            return state;
    }
}

export function InstallerListVehicleEventsReducer(state = Helpers.InstallerListVehicleEvents(), action) {
    switch (action.type) {
        case 'installerListVehicleEvents/UPDATE':
            return Helpers.InstallerListVehicleEvents();
        case 'installerListVehicleEvents/INSTALLER':
            return Helpers.SingleInstallerListVehicleEvents(action.installerID, action.event);
        case 'installerListVehicleEvents/NEW_EVENT':             
            return Helpers.addNewEvent(action.installerID, action.event);
        case 'installerListVehicleEvents/DELETE_EVENT':
            return Helpers.deleteEvent(action.event);
        default:
            return state;
    }
}

export function VehicleListReducer(state = Helpers.VehicleList(), action) {
    switch (action.type) {
        case 'vehicleList/UPDATE':
            return Helpers.VehicleList();
        case 'vehicleList/VEHICLE_ASSOCIATED_JOB':
            return Helpers.VehiclesAssociatedWithJobList(state, action.jobId);
        default:
            return state;
    }
}

export function AccountListReducer(state = Helpers.AccountList(), action) {
    switch (action.type) {
        case 'accountList/UPDATE':
            return Helpers.AccountList();
        default:
            return state;
    }
}